// User pool name: GlueID User pool - xr6hh
// User pool ID: us-east-2_WIjHi3eDS
// region: us-east-2 (no change)
// App client ID: 

// App client name: GlueID SPA app - xr6hh

const config = {
  Auth: {
    Cognito: {
      region: 'us-east-2',
      userPoolId: 'us-east-2_WIjHi3eDS',
      userPoolClientId: '1ihbkuqbc6j2e3ntf9b0ng4lk2',
    },
  },
};

export default config;
